import React, { useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Bubble.css";
import { CommentOutlined, CustomerServiceOutlined, PlusOutlined } from '@ant-design/icons';
import { FloatButton } from 'antd';
import { FaTasks } from "react-icons/fa";
import { GrDocumentText } from "react-icons/gr";
import { LuCalendarDays } from "react-icons/lu";

const Bubble = () => {
  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );

  return (
    <>
      <FloatButton.Group
        trigger="click"
        type="primary"
        style={{ insetInlineEnd: 30 }}
        icon={<PlusOutlined />}
      >
        <a href={`${env}/TaskDashboard/TaskAssignment?type=adhoc`}>
          <FloatButton
            tooltip={<div>New Task</div>}
            description="Task"
            icon={<FaTasks />}
          />
        </a>

        <a href={`${env}/TicketDashboard/TicketAssignment?type=adhoc`}>
          <FloatButton
            tooltip={<div>New Ticket</div>}
            description="Ticket"
            icon={<GrDocumentText />}
          />
        </a>
        <a href={`${env}/master/leaveRequest/edit`}>
          <FloatButton
            tooltip={<div>Request Leave Absence</div>}
            description="Leave"
            icon={<LuCalendarDays />}
          />
        </a>
      </FloatButton.Group>
      {/* <OverlayTrigger
        trigger="click"
        placement="left"
        rootClose
        overlay={
          <Popover>
            <Popover.Body>
              <div className="add_cond">
                {/* <Link to={""} className="text-black">
                  <div className="my-1">
                    <i className="fa fa-plus" title=""></i> In / Out Time
                  </div>
                </Link> 
                <Link
                  to={`${env}/TaskDashboard/TaskAssignment?type=adhoc`}
                  className="text-white">
                  <div className="my-1">
                    <i className="fa fa-plus" title=""></i> New Task
                  </div>
                </Link>
                <Link
                  to={`${env}/TicketDashboard/TicketAssignment?type=adhoc`}
                  className="text-white">
                  <div className="my-1">
                    <i className="fa fa-plus" title=""></i> New Ticket
                  </div>
                </Link>
                <Link
                  to={`${env}/master/leaveRequest/edit`}
                  className="text-white">
                  <div className="my-1">
                    <i className="fa fa-plus" title=""></i> Request / Leave
                    Absence
                  </div>
                </Link>
              </div>
            </Popover.Body>
          </Popover>
        }>
       
        <a className="float add_plus" onClick={(e) => e.preventDefault()}>
          <i className="fa fa-plus my-float"></i>
        </a>
    
      </OverlayTrigger> */}
    </>
  );
};

export default Bubble;
